import { Page, withModel } from '@adobe/cq-react-editable-components';
import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import GlobalFonts from './fonts/fonts';
import Modal from './components/Modal/Modal';

// This component is the application entry point
class App extends Page {
  render() {
    return (
      <>
        <ErrorBoundary>
          <GlobalFonts />
          <Modal />
          {this.childComponents}
          {this.childPages}
        </ErrorBoundary>
      </>
    );
  }
}

export default withModel(App);
